import { ReferenceTableInitializedEvent, } from '../event/reference-table-initialized.event';
import { ReferenceTableItemEntity } from '../reference-table-item.entity';
const referenceTableInitializedProjections = {
    [ReferenceTableInitializedEvent.name]: (event, state) => {
        const payload = event.getPayload();
        const items = new Map();
        payload.items.forEach(({ itemId, attributes, tp2LookupTableItemId }) => {
            const item = new ReferenceTableItemEntity({
                id: itemId,
                attributes,
                tp2LookupTableItemId,
            });
            items.set(itemId, item);
        });
        return {
            ...state,
            ...payload,
            description: payload.description || '',
            items,
            deleted: false,
        };
    },
};
export default referenceTableInitializedProjections;
//# sourceMappingURL=reference-table-initialized.projection.js.map